import React, { Suspense, lazy, useRef, useCallback } from "react";
import { ClipLoader } from "react-spinners";
import { useLocation, useNavigate } from "react-router-dom";

const RecordingTidalBreathing = lazy(
  () => import("recordingTidalBreathing/App"),
);

const DEMO_RECORDING_DURATIONS_SECONDS = new Set([15, 30, 60]);

function getRecordingDurationSecondsOverride({
  appMode,
  variant,
  search,
  fallback,
}) {
  if (appMode !== "respiratory" && variant !== "RecordingTidalBreathing") {
    return fallback;
  }

  const params = new URLSearchParams(search);
  const rawValue = params.get("recordingDurationSeconds");
  const parsedValue = Number(rawValue);

  if (
    !Number.isInteger(parsedValue) ||
    !DEMO_RECORDING_DURATIONS_SECONDS.has(parsedValue)
  ) {
    return fallback;
  }

  return parsedValue;
}

export default function RecordingTidalBreathingRouter(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const didRedirectRef = useRef(false);
  const recordingDurationSeconds = getRecordingDurationSecondsOverride({
    appMode: props.appMode,
    variant: props.variant,
    search: location.search,
    fallback: props.recordingDurationSeconds,
  });

  const handleUploadStatus = useCallback(
    (nextStatus) => {
      props.onUploadStatus?.(nextStatus);

      // Optional: route away from /recording/spirometry/camera once upload begins
      if (nextStatus === "uploading" && !didRedirectRef.current) {
        didRedirectRef.current = true;
        navigate("/recording/tidal-breathing", { replace: true });
      }
    },
    [navigate, props],
  );

  return (
    <Suspense
      fallback={
        <div className="flex h-full w-full items-center justify-center">
          <ClipLoader size={48} />
        </div>
      }
    >
      <RecordingTidalBreathing
        {...props}
        recordingDurationSeconds={recordingDurationSeconds}
        onUploadStatus={handleUploadStatus}
        onUploadProgress={props.onUploadProgress}
      />
    </Suspense>
  );
}
